import { render, staticRenderFns } from "./HeaderConfigs.vue?vue&type=template&id=5c13f29c&scoped=true"
import script from "./HeaderConfigs.vue?vue&type=script&lang=js"
export * from "./HeaderConfigs.vue?vue&type=script&lang=js"
import style0 from "./HeaderConfigs.vue?vue&type=style&index=0&id=5c13f29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13f29c",
  null
  
)

export default component.exports